import {Component} from 'react';

class Chart extends Component {
    state = {
        options: {}
    };

    /**
     * Only allow component to update for initialization, prevent re-renders after it has loaded.
     *
     * @param nextState
     * @return {boolean}
     */
    shouldComponentUpdate(nextState){
        return !(Object.keys(this.state.options).length > 0 || !nextState);
    }

    /**
     * Read CSV File and update options
     *
     * @return {options}
     * @param options
     * @param data
     * @param scale
     * @param names
     */
    readCSV = (options, data, scale, names) => {
        // split csv by lines
        const allLines = data.split('\n');
        // if in YYYY-mm-dd then 0, if YYYY-mm then 1,  if in mm/dd/YYYY then 2
        let utcFormat = 0;
        // iterate through each line
        allLines.forEach((line, lineNo) => {
            const items = line.split(',');
            // set names of data
            if (lineNo === 0) {
                // make sure series is defined
                // eslint-disable-next-line no-param-reassign
                options.series = [];
                // loop through first line to instantiate and name series
                items.forEach((item, itemNo) => {
                    if (itemNo > 0) {
                        options.series.push({
                            name: names[itemNo - 1],
                            data: []
                        });
                    }
                });
            } else {
                let date = [];
                items.forEach((item, itemNo) => {
                    // first set date associated with points
                    if (itemNo === 0) {
                        // split date into day, month, year
                        date = item.trim().split(/[./-]/);
                        if (lineNo === 1) {
                            const dateFormat = date[0].length;
                            // check if it is in YYYY-mm format
                            if (date.length === 2){
                                utcFormat = 1;
                            }
                            // if in mm/dd/YYYY then 1
                            else if (dateFormat < 4){
                                utcFormat = 2;
                            }
                        }
                    }
                    // if item is NA or 0 do not add to series! (NOTE keep != 0 do not put !== 0)
                    else if ( (item.trim() !== 'NA') && (item !== 0)) {
                        // add data to respective series
                        // YYYY-mm-dd
                        if (utcFormat === 0){
                            options.series[itemNo - 1].data.push([Date.UTC(date[0], date[1] - 1, date[2]), (parseFloat(item) / scale)]);
                        }
                        // YYYY-mm
                        else if (utcFormat === 1){
                            options.series[itemNo - 1].data.push([Date.UTC(date[0], date[1] - 1), (parseFloat(item) / scale)]);
                        }
                        // mm/dd/YYY
                        else{
                            options.series[itemNo - 1].data.push([Date.UTC(date[2], date[0] - 1, date[1]), (parseFloat(item) / scale)]);
                        }
                    }
                });
            }
        });
    };
}

export default Chart;



// WEBPACK FOOTER //
// ./frontend/components/Charts/Chart.jsx